export interface HolidayShippingNoticeSchedule {
  /** SGT `yyyy-MM-dd HH:mm:ss` the notice starts showing */
  startAt: string;
  /** SGT `yyyy-MM-dd HH:mm:ss` the notice stops showing (exclusive) */
  endAt: string;
}

export const HOLIDAY_SHIPPING_NOTICE_TIMEZONE = 'Asia/Singapore';

// Chuseok 2026 (SSD-6782): shown through Sep 28 SGT for every country. Changing a date needs a web deploy and an app OTA update.
export const HOLIDAY_SHIPPING_NOTICE_SCHEDULE: HolidayShippingNoticeSchedule = {
  startAt: '2026-09-17 00:00:00',
  endAt: '2026-09-29 00:00:00',
};

// Static for this campaign; shared by the webapp and the app, which each own only the styling
export const HOLIDAY_SHIPPING_NOTICE_MESSAGE =
  'Due to the Korean Chuseok holiday, order processing and shipping may take longer than usual';
